// Single source of truth for KUR sites. Consumed by the map component and
// the homepage network explorer.

export const stateLocations = {
  Texas: ["Dallas", "Corpus Christi", "San Antonio"],
  Alabama: ["Centerville", "Bessemer"],
  Florida: ["Fort Walton", "Tamarac", "Boca Raton", "Delray Beach", "Miami"],
  Maryland: ["Columbia"],
};

// [longitude, latitude]
export const cityCoordinates = {
  "Boca Raton": [-81.0123, 26.3683],
  Tamarac: [-80.4498, 26.1329],
  "Fort Walton": [-86.6085, 30.4258],
  "Delray Beach": [-80.0728, 26.4615],
  Miami: [-80.1918, 25.7617],
  Dallas: [-96.797, 32.7767],
  "Corpus Christi": [-97.3964, 27.8006],
  "San Antonio": [-98.4936, 29.4241],
  Columbia: [-76.8467, 39.2037],
  Centerville: [-87.2786, 32.8424],
  Bessemer: [-86.4544, 33.6018],
};

export const headquarters = "Dallas";
